export function haptic(pattern = 8) {
  try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (_) { /* unsupported */ }
}
